import React from 'react';

const inputCls =
  'w-full rounded-xl border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-pos-primary/30';

interface FieldProps {
  label: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

export function FormField({
  label,
  required,
  className,
  children,
}: FieldProps) {
  return (
    <div className={className}>
      <p className="mb-1 text-xs font-medium text-gray-700">
        {label}
        {required && ' *'}
      </p>
      {children}
    </div>
  );
}

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  fieldClassName?: string;
}

export function FormInput({
  label,
  fieldClassName,
  required,
  ...rest
}: InputProps) {
  return (
    <FormField label={label} required={required} className={fieldClassName}>
      <input required={required} className={inputCls} {...rest} />
    </FormField>
  );
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  fieldClassName?: string;
  children: React.ReactNode;
}

export function FormSelect({
  label,
  fieldClassName,
  required,
  children,
  ...rest
}: SelectProps) {
  return (
    <FormField label={label} required={required} className={fieldClassName}>
      <select required={required} className={inputCls} {...rest}>
        {children}
      </select>
    </FormField>
  );
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  fieldClassName?: string;
}

export function FormTextarea({
  label,
  fieldClassName,
  required,
  ...rest
}: TextareaProps) {
  return (
    <FormField label={label} required={required} className={fieldClassName}>
      <textarea required={required} className={inputCls} {...rest} />
    </FormField>
  );
}
